import { options } from '@master/model/options/Options'

const PaymentMethodList = ['Cash', 'Cheque', 'Credit Card', 'Giro', 'Others']
export const PaymentMethodOptions: options[] = PaymentMethodList.map(paymentMethod => {
  return {
    label: paymentMethod,
    value: paymentMethod
  }
})
